import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Auth } from '../auth/auth';
import { hasRole, hasPermission, RolId } from '../permissions/permissions';

export const roleGuard: CanActivateFn = (route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);

  const requiredRoles = route.data['roles'] as number[] | undefined;
  const requiredPermission = route.data['permission'] as string | undefined;

  const user = auth.user();
  
  if (!user) {
    router.navigate(['/login'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }

  if (requiredRoles && !hasRole(requiredRoles, user.idRol)) {
    router.navigate(['/home']);
    return false;
  }

  if (requiredPermission && !hasPermission(requiredPermission, user.idRol as RolId)) {
    router.navigate(['/home']);
    return false;
  }

  return true;
};
